import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const FormContracts = () => {
  return (
    <SettingsMetaData propertyName={"Form_Selection_Contracts"} viewPropertyName={"Form Selection"} />
  );
};
export default FormContracts;